module.exports = __webpack_public_path__ + "img/step2.f0e9e371.png";